module.exports = __webpack_public_path__ + "img/meeting-step.d3357cc6.png";